import { AppContent } from '../AppContent';

const smsOtpAuthorise: AppContent['smsOtpAuthorise'] = {
  smsOtpAuthoriseContent: [
    {
      serviceName: 'Online for Business',
      loaderMessage: 'Just a minute...',
      smsOtpAuthorisePath: '/sms-otp/authorise',
      smsOtpErrorPath: '/sms-otp-verification-error',
      redirectPath: '/redirect',
      technicalErrorPath: '/technical-error',
      idvPath: '/idv',
      submitRegistrationPath: '/submit-your-registration',
    },
  ],
};

export default smsOtpAuthorise;
